import { styled, theme, utils } from 'ui/theme';

export const FooterComponents = {
  Principal: styled.footer`
    background-color: ${theme.colors.build.lightLight};
    padding: ${theme.space[4]} 0;
  `,
  Section: styled.div`
    max-width: calc(${theme.sizes[22]} * 3);
  `,
  Base: styled.div`
    display: flex;
    align-items: flex-start;
    gap: calc(${theme.space[15]} * 2);
    padding: 0;
    ${utils.media.max('l')`
      padding: ${theme.space[7]} 0;
    `}
  `,
  Title: styled.h3`
    font-style: normal;
    font-size: ${theme.fontSizes.lg};
    line-height: 1.5rem;
    font-weight: ${theme.fontWeights.regular};
    padding-bottom: ${theme.space[2]};
    font-family: ${theme.fonts.primary};
    color: ${theme.colors.build.darkLight};
    margin: 0;
  `,
};
